var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"admin-vacancies-scene"},[_vm._v("\n  "+_vm._s(_vm.filterCompany)+"\n  "),(!_vm.loading)?_c('status-list',{attrs:{"list":_vm.statuses},on:{"sort_change":_vm.fetch}}):_c('vpreloader')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }